<script lang="ts">
  import { onMount } from "svelte";

  import { derived } from "svelte/store";

  import type { File } from "../scripts/FileTypes";
  import Path from "../scripts/Path";
  import type { Theme } from "../scripts/WinTypes";
  import { FileMgr } from "../stores/FileMgr";
  import SettingsMgr from "../stores/SettingsMgr";
  export let file: File;

  const thememgr = SettingsMgr.getInstance();
  let _theme = thememgr.theme;
  const themeWatcher = (theme: Theme) => {
    const c = theme.colors;
    return c;
  };
  $: _colors = themeWatcher($_theme);

  const filemgr = FileMgr.getInstance();
  let updateExists = () => {
    return filemgr
      .findDirValue(new Path(file.node.path.parent))
      .files.some((f) => f.node.isSame(file.node));
  };
  let exists: boolean = updateExists();

  const onClick = (e) => {
    if (filemgr.findFile(file.node.path)) {
      //remove;
      filemgr.rm(file.node.path);
    } else {
      filemgr.addFile(file);
    }
    exists = updateExists();
  };
  onMount(() => {
    _colors = themeWatcher($_theme);
  });
</script>

<div class="item-container">
  <div class="item" on:click={onClick}>
    <!-- <span class="check">V</span> -->
    <span class="icon-container">
      {#if exists}
        <img
          src="/imgs/circlecheck.svg"
          alt="App installed on desktop"
          class="icon"
          style={`background-color:${_colors["okay"] + "aa"}`}
        />
      {:else}
        <img
          src="/imgs/circledash.svg"
          alt="App not installed"
          class="icon"
          style={`background-color:${_colors["warn"] + "aa"}`}
        />
      {/if}
    </span>

    <div class="img-container">
      <img class="icon" src={file.node.iconPath} alt={file.node.path.path} />
    </div>
    <div class="name">{file.node.path.last}</div>
  </div>
</div>

<style>
  .item-container {
    width: 120px;
    height: 140px;
  }
  .icon {
    width: 100%;
    height: 100%;
  }
  .item {
    position: relative;
    transition: 0.2s;
    border-radius: 5px;
  }
  .item:hover {
    box-shadow: 2px 2px 4px #333;
    transform: translate(-2px, -2px);
    cursor: pointer;
  }
  .item:active {
    box-shadow: 0px 0px 0px #3330;
    transform: translate(0px, 0px);
    transition: 0.1s;
    cursor: pointer;
  }
  .icon-container {
    display: inline-block;
    position: absolute;
    top: 0px;
    left: 0px;
    transform: translate(-50%, -50%);
    width: 30px;
    height: 30px;
    color: #333;
    border-radius: 15px;
    /* border: 1px solid black; */
    text-align: center;
    font-size: 1.2rem;
    overflow: hidden;
  }
  .icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center center;
  }
  .check.not {
    background-color: #ffdf28;
  }
  .name {
    text-align: center;
    font-size: 1.3rem;
  }
</style>
